import { Progress as _Progress } from 'antd5';
import styled from 'styled-components';

export const Progress = styled(_Progress)`
  .ant-progress-text {
    color: ${({ theme }) => theme.headerColor} !important;
  }
`;
